import React from 'react';
import ExpandableListItem from '../../../../components/molecules/expandable_element';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import useStyles from './styles';
import FilterForm from './filter_form';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from '../../configuration';

interface IProps {
  vatNumber: string | null;
  year: string | null;
  period: string | null;
  remindedDateFrom: Date | null;
  remindedDateTo: Date | null;
}

const Filter = (props: IProps) => {
  const classes = useStyles();

  const Header = () => {
    return (
      <div className={classes.filter_header}>
        <SearchIcon style={{ marginRight: '1rem' }} />
        <span style={{ fontSize: '1.2rem' }}>
          <TranslatedText textMap={Translations.search} />
        </span>
      </div>
    );
  };

  return (
    <div
      className={clsx({
        [classes.cardLayout]: true,
        [classes.filter]: true,
      })}
    >
      <ExpandableListItem
        renderDataHeader={() => <Header />}
        renderDataBody={() => (
          <FilterForm
            vatNumber={props.vatNumber}
            year={props.year}
            period={props.period}
            remindedDateFrom={props.remindedDateFrom}
            remindedDateTo={props.remindedDateTo}
          />
        )}
      />
    </div>
  );
};

export default Filter;
